/* Back-in-stock "Notify me" — per-variant request via Shopify's native
   contact form (real email to the store, see mbg-notify-me.liquid for why
   this is genuine and not a fake integration). Submits via fetch so it
   never leaves the current page and — since a collection page can have
   many of these panels at once, one per sold-out size across many cards —
   never falls into Shopify's single shared form.posted_successfully? state
   showing "thanks" on every panel at once after a real page reload. If JS
   fails to load, the form still submits for real (full page reload); only
   this enhanced, no-reload behaviour is lost. */
(function () {
  'use strict';

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-mbg-notify-me-trigger]');
    if (!trigger) {
      return;
    }
    var panelId = trigger.getAttribute('aria-controls');
    var panel = panelId && document.getElementById(panelId);
    if (!panel) {
      return;
    }
    var isOpen = !panel.hidden;
    panel.hidden = isOpen;
    trigger.setAttribute('aria-expanded', String(!isOpen));
    if (!isOpen) {
      var emailField = panel.querySelector('input[type="email"]');
      if (emailField) {
        emailField.focus();
      }
    }
  });

  document.addEventListener('submit', function (evt) {
    var form = evt.target.closest('[data-mbg-notify-me-panel] form');
    if (!form) {
      return;
    }
    evt.preventDefault();

    var submitBtn = form.querySelector('.mbg-notify-me__submit');
    if (submitBtn) {
      submitBtn.disabled = true;
    }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Notify me request failed');
        }
        form.innerHTML = '<p class="mbg-notify-me__success">Thanks — we\'ll email you if this comes back in stock.</p>';
      })
      .catch(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
        }
        var existingError = form.querySelector('.mbg-notify-me__error');
        if (!existingError) {
          var error = document.createElement('p');
          error.className = 'mbg-notify-me__error';
          error.textContent = 'Something went wrong — please try again.';
          form.appendChild(error);
        }
      });
  });
})();
